import { useState } from 'react';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { type EnterpriseDomain } from 'src/api/endpoints/cloudEnterpriseAdminApi.types';
import { Button, Modal } from 'src/components';
import { StartEnterpriseDomainForwardingNotificationModal } from 'src/components/StartEnterpriseDomainForwardingNotificationModal';

export const DomainsTableCompleteMigration = ({
  domain,
}: {
  domain: EnterpriseDomain;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <>
      <Modal.Root
        open={isOpen}
        onOpenChange={(newState) => setIsOpen(newState)}
      >
        <Modal.Trigger asChild>
          <Button variant="tertiary" size="small">
            Complete migration
          </Button>
        </Modal.Trigger>
        <StartEnterpriseDomainForwardingNotificationModal
          componentLocation={ComponentLocations.ENTERPRISE.DOMAINS_PAGE}
          setIsOpen={setIsOpen}
          primaryDomain={domain}
        />
      </Modal.Root>
    </>
  );
};
